/* hl-bewegung – globale Bewegungsschicht für Helia Bad (Besitzer hl-rahmen, Vorlage Stilprobe 30.10.2026).
   Attribute:
     data-hl-reveal[="links|rechts|skala"]   einblenden, sobald sichtbar
     data-hl-stagger                         Kinder nacheinander einblenden
     data-hl-zaehler="17"                    hochzählen (Text im HTML ist schon der Endwert)
     data-hl-parallax="0.08"                 sanfte Verschiebung beim Scrollen
     data-hl-szene                           setzt --hl-p (0–1) für scrollgebundene Szenen, Ereignis "hl:szene"
     data-hl-bildfolge                       Bildfolge auf Canvas, läuft mit der Szene
     data-hl-bewegung="eigen"                globale Schicht lässt Element und Inhalt in Ruhe
     <details class="hl-…"> / data-hl-klappe   Klappe öffnet und schließt weich (data-hl-klappe="aus" = ohne)
     data-hl-einblenden[="blende"]           hidden umschalten = weich ein- und ausblenden
     hlBewegung.zeigen(el) / verstecken(el) / umschalten(el, an) / klappe(details, offen)
   Regeln: nur opacity/transform, nie das LCP-Element, prefers-reduced-motion = alles sofort sichtbar.
   Nachgeladene Inhalte (Theme-Editor, Warenkorb-Schublade): window.hlBewegung.scan(wurzel).
   Achtung Horizon: ab 990 px scrollt .page-wrapper statt des Fensters. window.scrollY bleibt dort 0 –
   hlBewegung.scrollY() / hlBewegung.scroller() benutzen, Scroll-Ereignisse mit {capture: true} am document. */
(function () {
  'use strict';
  var ruhig = window.matchMedia('(prefers-reduced-motion: reduce)');
  var VERSATZ = 70, MAX_STAFFEL = 8;
  var hl = window.hlBewegung = window.hlBewegung || {};
  hl.ruhig = ruhig.matches;
  /* Gemeinsame Helfer für alle Bereiche: wer scrollt, und wie weit (Fenster oder Horizons .page-wrapper ab 990 px) */
  hl.scroller = function () {
    var pw = document.querySelector('.page-wrapper');
    return pw && pw.scrollHeight > pw.clientHeight + 1 && getComputedStyle(pw).overflowY !== 'visible' ? pw : (document.scrollingElement || document.documentElement);
  };
  hl.scrollY = function () { var sc = hl.scroller(); return sc === document.scrollingElement || sc === document.documentElement ? window.scrollY : sc.scrollTop; };

  function eigen(el) { var e = el.closest('[data-hl-bewegung="eigen"]'); return e && e !== el; }
  function zeigen(el) { el.classList.add('hl-sichtbar'); }
  function alle(wurzel, sel) {
    var liste = Array.prototype.slice.call(wurzel.querySelectorAll(sel));
    if (wurzel !== document && wurzel.matches && wurzel.matches(sel)) liste.unshift(wurzel);
    return liste;
  }
  /* je Funktion ein eigenes Gedächtnis, damit ein Element mehrere Attribute tragen darf */
  var gesehen = { r: new WeakSet(), z: new WeakSet(), s: new WeakSet(), p: new WeakSet(), b: new WeakSet() };
  function neu(el, art) { if (gesehen[art].has(el)) return false; gesehen[art].add(el); return true; }

  /* 1 – Einblenden */
  var io = (!ruhig.matches && 'IntersectionObserver' in window) ? new IntersectionObserver(function (eintraege) {
    eintraege.forEach(function (e) { if (e.isIntersecting) { zeigen(e.target); io.unobserve(e.target); } });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }) : null;

  function einblenden(wurzel) {
    var els = [];
    alle(wurzel, '[data-hl-reveal]').forEach(function (el) { if (!eigen(el) && neu(el, 'r')) els.push(el); });
    alle(wurzel, '[data-hl-stagger]').forEach(function (box) {
      if (eigen(box)) return;
      Array.prototype.forEach.call(box.children, function (kind, i) {
        if (!neu(kind, 'r')) return;
        kind.style.setProperty('--hl-delay', Math.min(i, MAX_STAFFEL) * VERSATZ + 'ms');
        els.push(kind);
      });
    });
    els.forEach(function (el) { if (io) io.observe(el); else zeigen(el); });
  }

  /* 2 – Zähler */
  var fmt = new Intl.NumberFormat('de-DE');
  function zaehler(wurzel) {
    alle(wurzel, '[data-hl-zaehler]').forEach(function (el) {
      if (eigen(el) || !neu(el, 'z') || ruhig.matches || !('IntersectionObserver' in window)) return;
      var ziel = parseFloat(el.getAttribute('data-hl-zaehler'));
      if (!isFinite(ziel)) return;
      el.style.display = 'inline-block';
      el.style.minWidth = el.getBoundingClientRect().width + 'px';   // keine Verschiebung beim Zählen
      if (el.getBoundingClientRect().top > window.innerHeight) el.textContent = '0';
      var start = null, dauer = parseInt(el.getAttribute('data-hl-dauer') || '1200', 10);
      var beob = new IntersectionObserver(function (e) {
        if (!e[0].isIntersecting) return;
        beob.disconnect();
        function schritt(t) {
          if (start === null) start = t;
          var x = Math.min(1, (t - start) / dauer), k = 1 - Math.pow(1 - x, 3);
          el.textContent = fmt.format(Math.round(ziel * k));
          if (x < 1) requestAnimationFrame(schritt);
        }
        requestAnimationFrame(schritt);
      }, { threshold: 0.6 });
      beob.observe(el);
    });
  }

  /* 3 – Szenen, Parallax, Bildfolgen: ein gemeinsamer Scroll-Takt */
  var szenen = [], parallax = [];
  function fortschritt(el) {
    var r = el.getBoundingClientRect(), vh = window.innerHeight;
    var weg = r.height > vh * 1.05 ? r.height - vh : r.height;
    return Math.max(0, Math.min(1, -r.top / Math.max(1, weg)));
  }
  var geplant = false;
  function takt() {
    geplant = false;
    szenen = szenen.filter(function (s) { return s.el.isConnected; });
    parallax = parallax.filter(function (o) { return o.el.isConnected; });
    szenen.forEach(function (s) {
      var p = ruhig.matches ? parseFloat(s.el.getAttribute('data-hl-szene-ruhe') || '0') : fortschritt(s.el);
      p = Math.round(p * 1000) / 1000;
      if (p === s.p) return;
      s.p = p;
      s.el.style.setProperty('--hl-p', p);
      s.el.dispatchEvent(new CustomEvent('hl:szene', { detail: p }));
    });
    var vh = window.innerHeight;
    parallax.forEach(function (o) {
      var r = o.el.getBoundingClientRect();
      if (r.bottom < -100 || r.top > vh + 100) return;
      var mitte = r.top + r.height / 2 - vh / 2;
      o.el.style.transform = 'translate3d(0,' + (mitte * -o.f).toFixed(1) + 'px,0)';
    });
  }
  function anstoss() { if (!geplant) { geplant = true; requestAnimationFrame(takt); } }
  function szenenSuchen(wurzel) {
    alle(wurzel, '[data-hl-szene]').forEach(function (el) { if (neu(el, 's')) szenen.push({ el: el, p: -1 }); });
    if (!ruhig.matches) alle(wurzel, '[data-hl-parallax]').forEach(function (el) {
      if (!eigen(el) && neu(el, 'p')) parallax.push({ el: el, f: parseFloat(el.getAttribute('data-hl-parallax')) || 0.08 });
    });
  }
  /* Horizon: ab 990 px scrollt .page-wrapper, nicht das Fenster. Scroll-Ereignisse bubbeln nicht,
     deshalb in der Capture-Phase am document lauschen – das erfasst Fenster und jeden Scroll-Container. */
  document.addEventListener('scroll', anstoss, { passive: true, capture: true });
  window.addEventListener('resize', anstoss);
  if (ruhig.addEventListener) ruhig.addEventListener('change', function () { location.reload(); });

  /* 4 – Bildfolge auf Canvas (statt Autoplay-Video). Poster-<img> bleibt LCP und Ausweich. */
  function bildfolge(box) {
    var canvas = box.querySelector('canvas');
    if (!canvas || ruhig.matches) return;
    var verb = navigator.connection || {};
    if (verb.saveData || /(^|-)2g$/.test(verb.effectiveType || '')) return;
    // Handy bekommt eine eigene, leichtere Folge im Hochformat (data-hl-bilder-mobil), sonst dieselbe
    var mobil = window.matchMedia('(max-width: 959px)').matches && box.hasAttribute('data-hl-bilder-mobil');
    var sfx = mobil ? '-mobil' : '';
    var muster = box.getAttribute('data-hl-bilder' + sfx), n = parseInt(box.getAttribute('data-hl-anzahl' + sfx), 10) || 0;
    if (!muster || !n) return;
    var fokus = (box.getAttribute('data-hl-fokus' + sfx) || box.getAttribute('data-hl-fokus') || '50% 50%').split(' ').map(function (v) { return parseFloat(v) / 100; });
    var szene = box.closest('[data-hl-szene]') || box;
    var bilder = [], geladen = 0, aktuell = -1, ctx = canvas.getContext('2d');
    function groesse() {
      var r = box.getBoundingClientRect(), dpr = Math.min(2, window.devicePixelRatio || 1);
      canvas.width = Math.round(r.width * dpr); canvas.height = Math.round(r.height * dpr);
      aktuell = -1; zeichne(szene.style.getPropertyValue('--hl-p') || 0);
    }
    function zeichne(p) {
      if (geladen < n) return;
      var i = Math.min(n - 1, Math.max(0, Math.round(parseFloat(p) * (n - 1))));
      if (i === aktuell) return; aktuell = i;
      var img = bilder[i], cw = canvas.width, ch = canvas.height;
      var s = Math.max(cw / img.naturalWidth, ch / img.naturalHeight);
      var w = img.naturalWidth * s, h = img.naturalHeight * s;
      ctx.drawImage(img, (cw - w) * fokus[0], (ch - h) * fokus[1], w, h);
    }
    function laden() {
      for (var i = 0; i < n; i++) {
        var img = new Image();
        img.decoding = 'async';
        img.onload = function () {
          if (++geladen === n) { groesse(); box.classList.add('hl-bildfolge--bereit'); }
        };
        img.src = muster.replace('{ii}', (i < 10 ? '0' : '') + i).replace('{i}', i);
        bilder.push(img);
      }
    }
    szene.addEventListener('hl:szene', function (e) { zeichne(e.detail); });
    window.addEventListener('resize', function () { if (geladen === n) groesse(); });
    /* HELIA: requestIdleCallback braucht window als this und ein Options-Objekt, sonst TypeError */
    var los = function () {
      if (window.requestIdleCallback) window.requestIdleCallback(laden, { timeout: 1500 });
      else setTimeout(laden, 200);
    };
    if (document.readyState === 'complete') los(); else window.addEventListener('load', los);
  }

  /* 5 – Klappen: jedes <details> mit einer hl-Klasse (hl-klappe, hl-pd-klappe, hl-m-toc__klappe, hl-schublade__gruppe …)
     oder mit data-hl-klappe öffnet und schließt weich (Höhe + Inhalt blendet). Pfeil dreht über CSS mit.
     Ausnehmen: data-hl-klappe="aus" am <details> oder data-hl-bewegung="eigen" an einem Vorfahren.
     Bei prefers-reduced-motion bleibt alles wie im Browser (sofort). Horizons eigene Klappen bleiben unberührt. */
  var KLAPPE_DAUER = 340;
  function klappeMachtMit(d) {
    if (!d || d.tagName !== 'DETAILS') return false;
    if (d.getAttribute('data-hl-klappe') === 'aus' || d.closest('[data-hl-bewegung="eigen"]')) return false;
    return d.hasAttribute('data-hl-klappe') || /(^|\s)hl-/.test(d.className);
  }
  function geschlosseneHoehe(d, summary) {
    var cs = getComputedStyle(d);
    return summary.offsetHeight + parseFloat(cs.borderTopWidth) + parseFloat(cs.borderBottomWidth) + parseFloat(cs.paddingTop) + parseFloat(cs.paddingBottom);
  }
  function inhalt(d) { return Array.prototype.filter.call(d.children, function (k) { return k.tagName !== 'SUMMARY'; }); }
  function klappeAnimieren(d, oeffnen) {
    var summary = d.querySelector(':scope > summary');
    if (!summary) { d.open = oeffnen; return; }
    if (d.hlKlappe) { d.hlKlappe.cancel(); d.hlKlappe = null; }
    var start = d.offsetHeight, ende;
    d.style.overflow = 'hidden';
    if (oeffnen) {
      d.open = true;
      d.style.height = '';
      ende = d.offsetHeight;
      inhalt(d).forEach(function (k) { k.animate([{ opacity: 0, transform: 'translateY(-6px)' }, { opacity: 1, transform: 'none' }], { duration: KLAPPE_DAUER, easing: 'cubic-bezier(.2,.7,.2,1)' }); });
    } else {
      d.classList.add('ist-schliessend');
      ende = geschlosseneHoehe(d, summary);
      inhalt(d).forEach(function (k) { k.animate([{ opacity: 1 }, { opacity: 0 }], { duration: KLAPPE_DAUER * 0.6, easing: 'linear', fill: 'forwards' }); });
    }
    var a = d.animate([{ height: start + 'px' }, { height: ende + 'px' }], { duration: KLAPPE_DAUER, easing: 'cubic-bezier(.2,.7,.2,1)' });
    d.hlKlappe = a;
    a.onfinish = function () {
      d.hlKlappe = null;
      if (!oeffnen) {
        d.open = false;
        d.classList.remove('ist-schliessend');
        inhalt(d).forEach(function (k) { k.getAnimations().forEach(function (x) { x.cancel(); }); });
      }
      d.style.height = ''; d.style.overflow = '';
    };
    a.oncancel = function () { d.classList.remove('ist-schliessend'); d.style.height = ''; d.style.overflow = ''; };
  }
  document.addEventListener('click', function (e) {
    if (ruhig.matches || e.defaultPrevented) return;
    var summary = e.target.closest && e.target.closest('summary');
    if (!summary) return;
    var d = summary.parentElement;
    if (!klappeMachtMit(d) || summary !== d.querySelector(':scope > summary')) return;
    if (e.target.closest('a, button, input, label, select, textarea') && e.target.closest('a, button, input, label, select, textarea') !== summary) return;
    e.preventDefault();
    var oeffnen = !d.open || d.classList.contains('ist-schliessend');
    klappeAnimieren(d, oeffnen);
  });
  hl.klappe = function (d, oeffnen) { if (ruhig.matches) { d.open = oeffnen; return; } if (d.open !== oeffnen || d.classList.contains('ist-schliessend')) klappeAnimieren(d, oeffnen); };

  /* 6 – Ein- und Ausblenden: data-hl-einblenden an einem Element genügt. Wer dann el.hidden = true/false setzt
     (oder toggleAttribute('hidden')), bekommt die Bewegung automatisch: Höhe + Deckkraft (Standard) oder
     data-hl-einblenden="blende" für Überlagerungen (nur Deckkraft + 6 px). Direkt aufrufbar:
     hlBewegung.zeigen(el), hlBewegung.verstecken(el), hlBewegung.umschalten(el, an). Bei weniger Bewegung sofort. */
  var BLENDE_DAUER = 300;
  function nurBlende(el) { return el.getAttribute('data-hl-einblenden') === 'blende'; }
  function setzeHidden(el, wert) { el.hlSelbst = true; el.hidden = wert; }
  function blendeLauf(el, rein) {
    if (el.hlBlende) { el.hlBlende.cancel(); el.hlBlende = null; }
    var rahmen;
    if (nurBlende(el)) {
      rahmen = rein ? [{ opacity: 0, transform: 'translateY(-6px)' }, { opacity: 1, transform: 'none' }]
                    : [{ opacity: 1, transform: 'none' }, { opacity: 0, transform: 'translateY(-6px)' }];
    } else {
      var h = el.offsetHeight;
      el.style.overflow = 'hidden';
      rahmen = rein ? [{ height: '0px', opacity: 0 }, { height: h + 'px', opacity: 1 }]
                    : [{ height: h + 'px', opacity: 1 }, { height: '0px', opacity: 0 }];
    }
    var a = el.animate(rahmen, { duration: BLENDE_DAUER, easing: 'cubic-bezier(.2,.7,.2,1)' });
    el.hlBlende = a;
    a.onfinish = function () { el.hlBlende = null; el.style.overflow = ''; if (!rein) setzeHidden(el, true); };
    a.oncancel = function () { el.style.overflow = ''; };
  }
  hl.zeigen = function (el) {
    if (!el) return;
    setzeHidden(el, false);
    if (!ruhig.matches) blendeLauf(el, true);
  };
  hl.verstecken = function (el) {
    if (!el || (el.hidden && !el.hlBlende)) return;
    if (ruhig.matches) { setzeHidden(el, true); return; }
    setzeHidden(el, false);
    blendeLauf(el, false);
  };
  hl.umschalten = function (el, an) { if (an) hl.zeigen(el); else hl.verstecken(el); };
  if ('MutationObserver' in window) {
    new MutationObserver(function (liste) {
      liste.forEach(function (m) {
        var el = m.target;
        if (!el.hasAttribute || !el.hasAttribute('data-hl-einblenden')) return;
        if (el.hlSelbst) { el.hlSelbst = false; return; }
        if (ruhig.matches) return;
        var jetztVersteckt = el.hasAttribute('hidden'), vorher = m.oldValue !== null;
        if (jetztVersteckt === vorher) return;
        if (jetztVersteckt) { setzeHidden(el, false); blendeLauf(el, false); }   // noch vor dem Zeichnen zurückholen und ausblenden
        else blendeLauf(el, true);
      });
    }).observe(document.documentElement, { attributes: true, attributeFilter: ['hidden'], attributeOldValue: true, subtree: true });
  }

  /* Alles zusammen; scan() ist auch für nachgeladene Inhalte da */
  hl.scan = function (wurzel) {
    wurzel = wurzel || document;
    einblenden(wurzel);
    zaehler(wurzel);
    szenenSuchen(wurzel);
    alle(wurzel, '[data-hl-bildfolge]').forEach(function (box) { if (neu(box, 'b')) bildfolge(box); });
    anstoss();
  };
  hl.scan(document);

  /* Theme-Editor: neu geladene Abschnitte erfassen */
  document.addEventListener('shopify:section:load', function (e) { hl.scan(e.target); });

  hl.bereit = true;
})();
